/* eslint-disable react/prop-types */

const fmt = (n) => (n ? new Intl.NumberFormat("vi-VN").format(n) : "");

export const getPrintTemplate = ({ headerInfo, rows, totals }) => {
  const rowsHtml = rows
    .map(
      (row) => `
      <tr>
        <td class="text-center">${row.stt || ""}</td>
        <td>${row.tenTscd || ""}</td>
        <td class="text-center">${row.dvt || ""}</td>
        <td class="text-center">${row.maSo || ""}</td>
        <td class="text-center">${row.noiSuDung || ""}</td>
        <td class="text-right">${fmt(row.bookQuantity)}</td>
        <td class="text-right">${fmt(row.bookCost)}</td>
        <td class="text-right">${fmt(row.bookRemValue)}</td>
        <td class="text-right">${fmt(row.invQuantity)}</td>
        <td class="text-right">${fmt(row.invCost)}</td>
        <td class="text-right">${fmt(row.invRemValue)}</td>
        <td class="text-right">${fmt(row.diffQuantity)}</td>
        <td class="text-right">${fmt(row.diffCost)}</td>
        <td class="text-right">${fmt(row.diffRemValue)}</td>
        <td>${row.note || ""}</td>
      </tr>
    `
    )
    .join("");

  const committeeHtml = headerInfo.committee
    .map(
      (member) =>
        `<div>- Ông/Bà: ${member.name} Chức vụ ${member.position} Đại diện ${member.representative} ${member.role}</div>`
    )
    .join("");

  return `
    <html>
      <head>
        <title>In Biên Bản Kiểm Kê TSCĐ</title>
        <style>
          @media print {
            @page { margin: 10mm; size: landscape; }
          }
          body {
            font-family: "Times New Roman", Times, serif;
            color: #000;
            padding: 20px;
            font-size: 11px;
          }
          .header-top { display: flex; justify-content: space-between; margin-bottom: 20px; }
          .title-box { text-align: center; margin: 20px 0; }
          .title-main { font-size: 16px; font-weight: bold; margin: 0; text-transform: uppercase; }
          table { width: 100%; border-collapse: collapse; margin-top: 10px; }
          th, td { border: 1px solid #000; padding: 3px; }
          th { text-align: center; font-weight: bold; vertical-align: middle; font-size: 10px; }
          .text-center { text-align: center; }
          .text-right { text-align: right; }
          .bold { font-weight: bold; }
          .footer { display: flex; justify-content: space-between; margin-top: 30px; text-align: center; }
          .flex-row { display: flex; align-items: center; margin-bottom: 8px; }
        </style>
      </head>
      <body>
        <div class="header-top">
          <div style="width: 40%;">
            <div class="bold">Đơn vị: ${headerInfo.unit}</div>
            <div class="bold">Bộ phận: ${headerInfo.department}</div>
          </div>
          <div style="text-align: center; width: 60%;">
            <div class="bold">Mẫu số 05 - TSCĐ</div>
            <div style="font-style: italic; font-size: 11px;">
              (Kèm theo Thông tư số 99/2025/TT-BTC <br /> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)
            </div>
          </div>
        </div>

        <div class="title-box">
          <h2 class="title-main">BIÊN BẢN TỔNG HỢP KIỂM KÊ TÀI SẢN CỐ ĐỊNH</h2>
          <div class="text-right" style="margin-top: 10px;">
            Số: ${headerInfo.docNumber}
          </div>
        </div>

        <div style="margin-bottom: 10px;">
          <div class="flex-row">
            Thời điểm kiểm kê ${headerInfo.invHour} giờ ${headerInfo.invDay} ngày ${
    headerInfo.invMonth
  } tháng ${headerInfo.invYear} năm ....
          </div>
          <div style="margin-bottom: 5px;">Ban kiểm kê gồm:</div>
          ${committeeHtml}
          <div style="margin-top: 10px;">Đã kiểm kê TSCĐ, kết quả như sau:</div>
        </div>

        <table>
          <thead>
            <tr>
              <th rowspan="2">Số TT</th>
              <th rowspan="2" style="width: 160px;">Tên TSCĐ</th>
              <th rowspan="2">ĐVT</th>
              <th rowspan="2">Mã số</th>
              <th rowspan="2">Nơi sử dụng</th>
              <th colspan="3">Theo sổ kế toán</th>
              <th colspan="3">Theo kiểm kê</th>
              <th colspan="3">Chênh lệch</th>
              <th rowspan="2">Ghi chú</th>
            </tr>
            <tr>
              <th>Số lượng</th>
              <th>Nguyên giá</th>
              <th>Giá trị còn lại</th>
              <th>Số lượng</th>
              <th>Nguyên giá</th>
              <th>Giá trị còn lại</th>
              <th>Số lượng</th>
              <th>Nguyên giá</th>
              <th>Giá trị còn lại</th>
            </tr>
            <tr style="background-color: #fafafa;">
              <th>A</th>
              <th>B</th>
              <th>C</th>
              <th>D</th>
              <th>E</th>
              <th>1</th>
              <th>2</th>
              <th>3</th>
              <th>4</th>
              <th>5</th>
              <th>6</th>
              <th>7</th>
              <th>8</th>
              <th>9</th>
              <th>F</th>
            </tr>
          </thead>
          <tbody>
            ${rowsHtml}
            <tr style="font-weight: bold; background-color: #fff;">
              <td colspan="2" class="text-center">Cộng</td>
              <td class="text-center">x</td>
              <td class="text-center">x</td>
              <td class="text-center">x</td>
              <td class="text-center">x</td>
              <td class="text-right">${fmt(totals?.bookCost)}</td>
              <td class="text-right">${fmt(totals?.bookRemainingValue)}</td>
              <td class="text-center">x</td>
              <td class="text-right">${fmt(totals?.inventoryCost)}</td>
              <td class="text-right">${fmt(totals?.inventoryRemainingValue)}</td>
              <td class="text-center">x</td>
              <td class="text-right">${fmt(totals?.diffCost)}</td>
              <td class="text-right">${fmt(totals?.diffRemainingValue)}</td>
              <td class="text-center">x</td>
            </tr>
          </tbody>
        </table>

        <div class="footer">
          <div style="width: 33%;">
            <div class="bold">Giám đốc</div>
            <div style="font-style: italic; font-size: 13px;">(Ghi ý kiến giải quyết số chênh lệch)</div>
            <div style="font-style: italic; font-size: 13px; margin-bottom: 50px;">(Ký, họ tên, đóng dấu)</div>
            <div style="border-bottom: 1px dotted #000; width: 150px; margin: 0 auto; text-align: center;">${
              headerInfo.directorName
            }</div>
          </div>
          <div style="width: 33%;">
            <div class="bold">Kế toán trưởng</div>
            <div style="font-style: italic; font-size: 13px; margin-bottom: 65px;">(Ký, họ tên)</div>
            <div style="border-bottom: 1px dotted #000; width: 150px; margin: 0 auto; text-align: center;">${
              headerInfo.accountantName
            }</div>
          </div>
          <div style="width: 33%;">
            <div style="font-style: italic; margin-bottom: 5px;">
              Ngày ... tháng ... năm ...
            </div>
            <div class="bold">Trưởng Ban kiểm kê</div>
            <div style="font-style: italic; font-size: 13px; margin-bottom: 50px;">(Ký, họ tên)</div>
            <div style="border-bottom: 1px dotted #000; width: 150px; margin: 0 auto; text-align: center;">${
              headerInfo.headOfCommitteeName
            }</div>
          </div>
        </div>

        <div style="margin-top: 40px; font-size: 14px;">
          <b>Ghi chú:</b> <i style="text-decoration: underline;">Tùy</i> <i style="font-style: italic;">theo đặc điểm hoạt động sản xuất kinh doanh và yêu cầu quản lý của đơn vị mình, doanh nghiệp được xây dựng, thiết kế biểu mẫu chứng từ kế toán.</i>
        </div>

        <script>
          window.onload = function() {
            window.print();
          };
        </script>
      </body>
    </html>
  `;
};
